import { render, staticRenderFns } from "./Recipe.vue?vue&type=template&id=5a5080cf&scoped=true&"
import script from "./Recipe.vue?vue&type=script&lang=ts&"
export * from "./Recipe.vue?vue&type=script&lang=ts&"
import style0 from "./Recipe.vue?vue&type=style&index=0&id=5a5080cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5080cf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
